import { colors } from 'styles/colors';

import {
  LabelWrap,
  Radio,
  Cursor,
  Label,
} from './styles';
import { CSSProperties } from 'react';

type RadioButtonProps = {
  name?: string;
  checked: boolean;
  label?: string;
  checkedColor?: string;
  uncheckedColor?: string;
  onClick?: (() => void | Promise<void>) | null;
  style?: CSSProperties;
  variant?: 'new-radio';
  disabled?: boolean;
  circleSize?: number;
}

export const RadioButton = ({
  label,
  checked,
  checkedColor = colors.Blue300,
  uncheckedColor = colors.Grey400,
  onClick,
  variant,
  disabled,
  circleSize,
  ...props
}: Readonly<RadioButtonProps>): JSX.Element => (
  <LabelWrap
    uncheckedColor={uncheckedColor}
    onClick={() => onClick?.()}
    cursor={onClick ? 'pointer' : undefined}
    variant={variant}
    disabled={disabled}
    {...props}
  >
    <Radio checked={checked} color={checked ? checkedColor : uncheckedColor} variant={variant} disabled={disabled} circleSize={circleSize}>
      <Cursor checked={checked} color={checked ? checkedColor : colors.White} variant={variant} disabled={disabled} circleSize={circleSize} />
    </Radio>
    {label && <Label variant={variant} disabled={disabled}>{label}</Label>}
  </LabelWrap>
);
